/**
 * NewsIcon — sanitized from `assets/newSvg/news.svg`.
 * Artboard: 1024×1024 · viewBox 0 0 24 24 (fixed).
 */
import React from 'react';
import Svg, { Path } from 'react-native-svg';
import {
  APP_ICON_VIEW_BOX,
  useAppIconProps,
  type AppIconProps,
} from './iconBase';

export function NewsIcon(props: AppIconProps) {
  const { size, color, style, accessibilityLabel, testID, ...rest } = useAppIconProps(props);

  return (
    <Svg
      width={size}
      height={size}
      viewBox={APP_ICON_VIEW_BOX}
      style={style}
      accessibilityLabel={accessibilityLabel}
      testID={testID}
      {...rest}
    >
      <Path
        d="M16,3 C17.0543909,3 17.9181678,3.81587733 17.9945144,4.85073759 L18,5 L18,10 L19.5,10 C20.2796706,10 20.9204457,10.5949121 20.9931332,11.3555442 L21,11.5 L21,19 C21,20.597725 19.7511226,21.903664 18.1762773,21.9949075 L18,22 L5,22 C3.94563773,22 3.08183483,21.18415 3.00548573,20.1492661 L3,20 L3,5 C3,3.94563773 3.81587733,3.08183483 4.85073759,3.00548573 L5,3 L16,3 Z M19,12 L18,12 L18,20 C18.5523,20 19,19.5523 19,19 L19,12 Z M11,13 L8,13 C7.44772,13 7,13.4477 7,14 C7,14.51285 7.38604429,14.9355092 7.88337975,14.9932725 L8,15 L11,15 C11.5523,15 12,14.5523 12,14 C12,13.48715 11.613973,13.0644908 11.1166239,13.0067275 L11,13 Z M13,8 L8,8 C7.44772,8 7,8.44772 7,9 C7,9.55228 7.44772,10 8,10 L13,10 C13.5523,10 14,9.55228 14,9 C14,8.44772 13.5523,8 13,8 Z"
        fill={color}
      />
    </Svg>
  );
}

export default NewsIcon;
